"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../../hooks");
var _Avatar = require("../../../../UI/Avatar");
var _Button = require("../../../../UI/Button");
var _Menu = require("../../../../UI/Menu");
var _List = require("../../../../Data/List");
var _ListItem = require("../../../../Data/List/partials/ListItem");
var _UserRoles = require("./UserRoles");
var _Header = require("../Header.labels");
var _Header2 = _interopRequireDefault(require("../Header.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Profile = props => {
  const {
    isMobileView,
    lang,
    user,
    avatarUrl,
    onShowProfileClick,
    avatarSize = 'small'
  } = props;
  const {
    sendUiUsageEvent
  } = (0, _hooks.useCetEvents)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _Header.labels
  });
  const styles = (0, _Header2.default)(isMobileView, !Boolean(user?.userId));
  const menuRef = (0, _react.useRef)(null);
  const handleLogout = () => {
    window.cet.accessmanagement.logout(`${window.location.origin}/${lang}`);
    const categoryName = 'upperToolbar';
    const labelName = 'logout';
    sendUiUsageEvent({
      category: categoryName,
      label: labelName
    });
  };
  if (!user?.userId) return null;
  const avatar = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
    avatarUrl: avatarUrl ?? user?.userAvatarUrl,
    firstName: user?.firstName,
    lastName: user?.lastName,
    gender: user?.gender ?? 'male',
    size: avatarSize,
    withDefaultImage: true,
    ariaHidden: true
  });
  const btnProps = {
    view: 'alternate',
    color: 'basic',
    shape: 'roundedRectangle',
    customStyle: {
      paddingInline: 6
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [avatar, /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: styles['cc-Header__toolbar__profile__button'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-Header__toolbar__profile__button__name'],
          children: user?.firstName
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserRoles.UserRoles, {
          isMobileView: isMobileView,
          lang: lang,
          user: user
        })]
      })]
    }),
    ariaLabel: `${getLabel('view_my_profile')} ${user?.firstName}`
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    children: isMobileView ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      id: "ccHeaderProfileButton",
      ariaLabel: getLabel('view_my_profile'),
      onClick: onShowProfileClick,
      category: "upperToolbar",
      label: "showMyProfile",
      shape: "round",
      color: "basic",
      view: "text",
      children: avatar
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Menu.Menu, {
      btnProps: btnProps,
      ref: menuRef,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Header__profile-popup__title'],
        children: user?.displayName
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_List.List, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItem.ListItem, {
          id: "profile-view",
          size: "small",
          onClick: id => {
            onShowProfileClick();
            menuRef.current?.closeMenu();
          },
          children: getLabel('view_my_profile')
        }), user.hasMultipleRoles && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItem.ListItem, {
          id: "ccHeaderUserRolesButton",
          size: "small",
          color: "basic",
          onClick: () => {
            window.cet.accessmanagement.changeRole(window.location.href, null, lang);
          },
          children: getLabel('change_user_role')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItem.ListItem, {
          id: "profile-logout",
          size: "small",
          onClick: handleLogout,
          children: getLabel('logout')
        })]
      })]
    })
  });
};
exports.Profile = Profile;